module.exports = __webpack_public_path__ + "06_short_gold.7d75d7a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/dad/layer5/06_short_gold.png
// module id = O2YA
// module chunks = 0